import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkbox"];
  timeout = null; // used for debounce
  isSaving = false; // prevent multiple simultaneous saves

  connect() {
    this.blockId = this.element.dataset.blockId;
    this.blockType = 'checkboxes';
  }

  save(event) {
    // Mark this block as actively being edited
    window.activeEditingManager.startEditing(this.blockId, this.blockType, this.element);
    
    // Clear any previous scheduled save
    clearTimeout(this.timeout);

    // Set a new timeout to delay the save
    this.timeout = setTimeout(() => {
      this.performSave();
    }, 1500);
  }

  performSave() {
    // Prevent multiple simultaneous saves
    if (this.isSaving) {
      console.log("Save already in progress, skipping...");
      return;
    }

    this.isSaving = true;

    const checkboxes = this.element.querySelectorAll("input[type='checkbox']");
    const selectedValues = Array.from(checkboxes)
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value);

    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({
        task_block: { value: selectedValues },
        skip_broadcast: false // Always broadcast - the channel will skip updates for the editing user
      })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("Checkbox values saved successfully");
          // Stop editing after successful save
          window.activeEditingManager.stopEditing(blockId, 500); // Short debounce for successful saves
        } else {
          console.error("Failed to save checkbox values:", data);
          // Stop editing even on error to prevent stuck state
          window.activeEditingManager.stopEditing(blockId, 1000);
        }
      })
      .catch(error => {
        console.error("Error saving checkbox values:", error);
        // Stop editing on error
        window.activeEditingManager.stopEditing(blockId, 1000);
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    // Clean up editing state when controller disconnects
    if (this.blockId) {
      window.activeEditingManager.stopEditing(this.blockId, 0); // No debounce on disconnect
    }
  }
}
